// Database delle città italiane con province
// Formato: { city: "Nome Città", province: "XX", cap: "XXXXX" }

export const italianCities = [
  // ABRUZZO
  { city: "L'Aquila", province: "AQ", cap: "67100" },
  { city: "Avezzano", province: "AQ", cap: "67051" },
  { city: "Sulmona", province: "AQ", cap: "67039" },
  { city: "Chieti", province: "CH", cap: "66100" },
  { city: "Lanciano", province: "CH", cap: "66034" },
  { city: "Vasto", province: "CH", cap: "66054" },
  { city: "Ortona", province: "CH", cap: "66026" },
  { city: "Pescara", province: "PE", cap: "65100" },
  { city: "Montesilvano", province: "PE", cap: "65015" },
  { city: "Teramo", province: "TE", cap: "64100" },
  { city: "Giulianova", province: "TE", cap: "64021" },
  { city: "Roseto degli Abruzzi", province: "TE", cap: "64026" },
  
  // BASILICATA
  { city: "Potenza", province: "PZ", cap: "85100" },
  { city: "Matera", province: "MT", cap: "75100" },
  { city: "Melfi", province: "PZ", cap: "85025" },
  { city: "Pisticci", province: "MT", cap: "75015" },
  
  // CALABRIA
  { city: "Catanzaro", province: "CZ", cap: "88100" },
  { city: "Lamezia Terme", province: "CZ", cap: "88046" },
  { city: "Cosenza", province: "CS", cap: "87100" },
  { city: "Rende", province: "CS", cap: "87036" },
  { city: "Crotone", province: "KR", cap: "88900" },
  { city: "Reggio Calabria", province: "RC", cap: "89100" },
  { city: "Vibo Valentia", province: "VV", cap: "89900" },
  
  // CAMPANIA
  { city: "Napoli", province: "NA", cap: "80100" },
  { city: "Pozzuoli", province: "NA", cap: "80078" },
  { city: "Giugliano in Campania", province: "NA", cap: "80014" },
  { city: "Torre del Greco", province: "NA", cap: "80059" },
  { city: "Casoria", province: "NA", cap: "80026" },
  { city: "Castellammare di Stabia", province: "NA", cap: "80053" },
  { city: "Portici", province: "NA", cap: "80055" },
  { city: "Ercolano", province: "NA", cap: "80056" },
  { city: "Marano di Napoli", province: "NA", cap: "80016" },
  { city: "Afragola", province: "NA", cap: "80021" },
  { city: "Casalnuovo di Napoli", province: "NA", cap: "80013" },
  { city: "Salerno", province: "SA", cap: "84100" },
  { city: "Battipaglia", province: "SA", cap: "84091" },
  { city: "Cava de' Tirreni", province: "SA", cap: "84013" },
  { city: "Eboli", province: "SA", cap: "84025" },
  { city: "Nocera Inferiore", province: "SA", cap: "84014" },
  { city: "Scafati", province: "SA", cap: "84018" },
  { city: "Avellino", province: "AV", cap: "83100" },
  { city: "Ariano Irpino", province: "AV", cap: "83031" },
  { city: "Benevento", province: "BN", cap: "82100" },
  { city: "Caserta", province: "CE", cap: "81100" },
  { city: "Aversa", province: "CE", cap: "81031" },
  { city: "Maddaloni", province: "CE", cap: "81024" },
  { city: "Marcianise", province: "CE", cap: "81025" },
  { city: "Santa Maria Capua Vetere", province: "CE", cap: "81055" },
  
  // EMILIA-ROMAGNA
  { city: "Bologna", province: "BO", cap: "40100" },
  { city: "Imola", province: "BO", cap: "40026" },
  { city: "Casalecchio di Reno", province: "BO", cap: "40033" },
  { city: "San Lazzaro di Savena", province: "BO", cap: "40068" },
  { city: "Ferrara", province: "FE", cap: "44100" },
  { city: "Cento", province: "FE", cap: "44042" },
  { city: "Forlì", province: "FC", cap: "47121" },
  { city: "Cesena", province: "FC", cap: "47521" },
  { city: "Modena", province: "MO", cap: "41100" },
  { city: "Carpi", province: "MO", cap: "41012" },
  { city: "Sassuolo", province: "MO", cap: "41049" },
  { city: "Formigine", province: "MO", cap: "41043" },
  { city: "Parma", province: "PR", cap: "43100" },
  { city: "Fidenza", province: "PR", cap: "43036" },
  { city: "Piacenza", province: "PC", cap: "29121" },
  { city: "Ravenna", province: "RA", cap: "48121" },
  { city: "Faenza", province: "RA", cap: "48018" },
  { city: "Lugo", province: "RA", cap: "48022" },
  { city: "Reggio Emilia", province: "RE", cap: "42121" },
  { city: "Correggio", province: "RE", cap: "42015" },
  { city: "Scandiano", province: "RE", cap: "42019" },
  { city: "Rimini", province: "RN", cap: "47921" },
  { city: "Riccione", province: "RN", cap: "47838" },
  { city: "Santarcangelo di Romagna", province: "RN", cap: "47822" },
  
  // FRIULI-VENEZIA GIULIA
  { city: "Trieste", province: "TS", cap: "34100" },
  { city: "Udine", province: "UD", cap: "33100" },
  { city: "Pordenone", province: "PN", cap: "33170" },
  { city: "Gorizia", province: "GO", cap: "34170" },
  { city: "Monfalcone", province: "GO", cap: "34074" },
  
  // LAZIO
  { city: "Roma", province: "RM", cap: "00100" },
  { city: "Fiumicino", province: "RM", cap: "00054" },
  { city: "Guidonia Montecelio", province: "RM", cap: "00012" },
  { city: "Tivoli", province: "RM", cap: "00019" },
  { city: "Civitavecchia", province: "RM", cap: "00053" },
  { city: "Velletri", province: "RM", cap: "00049" },
  { city: "Anzio", province: "RM", cap: "00042" },
  { city: "Nettuno", province: "RM", cap: "00048" },
  { city: "Pomezia", province: "RM", cap: "00071" },
  { city: "Ardea", province: "RM", cap: "00040" },
  { city: "Ciampino", province: "RM", cap: "00043" },
  { city: "Monterotondo", province: "RM", cap: "00015" },
  { city: "Latina", province: "LT", cap: "04100" },
  { city: "Aprilia", province: "LT", cap: "04011" },
  { city: "Terracina", province: "LT", cap: "04019" },
  { city: "Formia", province: "LT", cap: "04023" },
  { city: "Fondi", province: "LT", cap: "04022" },
  { city: "Frosinone", province: "FR", cap: "03100" },
  { city: "Cassino", province: "FR", cap: "03043" },
  { city: "Alatri", province: "FR", cap: "03011" },
  { city: "Sora", province: "FR", cap: "03039" },
  { city: "Rieti", province: "RI", cap: "02100" },
  { city: "Viterbo", province: "VT", cap: "01100" },
  { city: "Civita Castellana", province: "VT", cap: "01033" },
  
  // LIGURIA
  { city: "Genova", province: "GE", cap: "16100" },
  { city: "Rapallo", province: "GE", cap: "16035" },
  { city: "Chiavari", province: "GE", cap: "16043" },
  { city: "Sestri Levante", province: "GE", cap: "16039" },
  { city: "Imperia", province: "IM", cap: "18100" },
  { city: "Sanremo", province: "IM", cap: "18038" },
  { city: "Ventimiglia", province: "IM", cap: "18039" },
  { city: "La Spezia", province: "SP", cap: "19100" },
  { city: "Sarzana", province: "SP", cap: "19038" },
  { city: "Savona", province: "SV", cap: "17100" },
  { city: "Albenga", province: "SV", cap: "17031" },
  { city: "Finale Ligure", province: "SV", cap: "17024" },
  
  // LOMBARDIA
  { city: "Milano", province: "MI", cap: "20100" },
  { city: "Sesto San Giovanni", province: "MI", cap: "20099" },
  { city: "Cinisello Balsamo", province: "MI", cap: "20092" },
  { city: "Legnano", province: "MI", cap: "20025" },
  { city: "Rho", province: "MI", cap: "20017" },
  { city: "Cologno Monzese", province: "MI", cap: "20093" },
  { city: "Paderno Dugnano", province: "MI", cap: "20037" },
  { city: "Corsico", province: "MI", cap: "20094" },
  { city: "Rozzano", province: "MI", cap: "20089" },
  { city: "San Donato Milanese", province: "MI", cap: "20097" },
  { city: "San Giuliano Milanese", province: "MI", cap: "20098" },
  { city: "Bergamo", province: "BG", cap: "24100" },
  { city: "Treviglio", province: "BG", cap: "24047" },
  { city: "Seriate", province: "BG", cap: "24068" },
  { city: "Dalmine", province: "BG", cap: "24044" },
  { city: "Brescia", province: "BS", cap: "25100" },
  { city: "Desenzano del Garda", province: "BS", cap: "25015" },
  { city: "Montichiari", province: "BS", cap: "25018" },
  { city: "Lumezzane", province: "BS", cap: "25065" },
  { city: "Como", province: "CO", cap: "22100" },
  { city: "Cantù", province: "CO", cap: "22063" },
  { city: "Mariano Comense", province: "CO", cap: "22066" },
  { city: "Cremona", province: "CR", cap: "26100" },
  { city: "Crema", province: "CR", cap: "26013" },
  { city: "Lecco", province: "LC", cap: "23900" },
  { city: "Merate", province: "LC", cap: "23807" },
  { city: "Lodi", province: "LO", cap: "26900" },
  { city: "Mantova", province: "MN", cap: "46100" },
  { city: "Monza", province: "MB", cap: "20900" },
  { city: "Seregno", province: "MB", cap: "20831" },
  { city: "Desio", province: "MB", cap: "20832" },
  { city: "Lissone", province: "MB", cap: "20851" },
  { city: "Cesano Maderno", province: "MB", cap: "20811" },
  { city: "Giussano", province: "MB", cap: "20833" },
  { city: "Pavia", province: "PV", cap: "27100" },
  { city: "Vigevano", province: "PV", cap: "27029" },
  { city: "Voghera", province: "PV", cap: "27058" },
  { city: "Sondrio", province: "SO", cap: "23100" },
  { city: "Varese", province: "VA", cap: "21100" },
  { city: "Busto Arsizio", province: "VA", cap: "21052" },
  { city: "Gallarate", province: "VA", cap: "21013" },
  { city: "Saronno", province: "VA", cap: "21047" },
  { city: "Tradate", province: "VA", cap: "21049" },
  
  // MARCHE
  { city: "Ancona", province: "AN", cap: "60100" },
  { city: "Senigallia", province: "AN", cap: "60019" },
  { city: "Jesi", province: "AN", cap: "60035" },
  { city: "Fabriano", province: "AN", cap: "60044" },
  { city: "Ascoli Piceno", province: "AP", cap: "63100" },
  { city: "San Benedetto del Tronto", province: "AP", cap: "63074" },
  { city: "Fermo", province: "FM", cap: "63900" },
  { city: "Porto Sant'Elpidio", province: "FM", cap: "63821" },
  { city: "Macerata", province: "MC", cap: "62100" },
  { city: "Civitanova Marche", province: "MC", cap: "62012" },
  { city: "Pesaro", province: "PU", cap: "61121" },
  { city: "Fano", province: "PU", cap: "61032" },
  { city: "Urbino", province: "PU", cap: "61029" },
  
  // MOLISE
  { city: "Campobasso", province: "CB", cap: "86100" },
  { city: "Termoli", province: "CB", cap: "86039" },
  { city: "Isernia", province: "IS", cap: "86170" },
  
  // PIEMONTE
  { city: "Torino", province: "TO", cap: "10100" },
  { city: "Moncalieri", province: "TO", cap: "10024" },
  { city: "Collegno", province: "TO", cap: "10093" },
  { city: "Rivoli", province: "TO", cap: "10098" },
  { city: "Nichelino", province: "TO", cap: "10042" },
  { city: "Settimo Torinese", province: "TO", cap: "10036" },
  { city: "Grugliasco", province: "TO", cap: "10095" },
  { city: "Chieri", province: "TO", cap: "10023" },
  { city: "Pinerolo", province: "TO", cap: "10064" },
  { city: "Venaria Reale", province: "TO", cap: "10078" },
  { city: "Chivasso", province: "TO", cap: "10034" },
  { city: "Ivrea", province: "TO", cap: "10015" },
  { city: "Alessandria", province: "AL", cap: "15121" },
  { city: "Casale Monferrato", province: "AL", cap: "15033" },
  { city: "Novi Ligure", province: "AL", cap: "15067" },
  { city: "Tortona", province: "AL", cap: "15057" },
  { city: "Asti", province: "AT", cap: "14100" },
  { city: "Biella", province: "BI", cap: "13900" },
  { city: "Cuneo", province: "CN", cap: "12100" },
  { city: "Alba", province: "CN", cap: "12051" },
  { city: "Bra", province: "CN", cap: "12042" },
  { city: "Fossano", province: "CN", cap: "12045" },
  { city: "Mondovì", province: "CN", cap: "12084" },
  { city: "Novara", province: "NO", cap: "28100" },
  { city: "Verbania", province: "VB", cap: "28922" },
  { city: "Vercelli", province: "VC", cap: "13100" },
  
  // PUGLIA
  { city: "Bari", province: "BA", cap: "70100" },
  { city: "Altamura", province: "BA", cap: "70022" },
  { city: "Molfetta", province: "BA", cap: "70056" },
  { city: "Bitonto", province: "BA", cap: "70032" },
  { city: "Monopoli", province: "BA", cap: "70043" },
  { city: "Corato", province: "BA", cap: "70033" },
  { city: "Barletta", province: "BT", cap: "76121" },
  { city: "Andria", province: "BT", cap: "76123" },
  { city: "Trani", province: "BT", cap: "76125" },
  { city: "Bisceglie", province: "BT", cap: "76011" },
  { city: "Brindisi", province: "BR", cap: "72100" },
  { city: "Fasano", province: "BR", cap: "72015" },
  { city: "Ostuni", province: "BR", cap: "72017" },
  { city: "Foggia", province: "FG", cap: "71121" },
  { city: "Cerignola", province: "FG", cap: "71042" },
  { city: "San Severo", province: "FG", cap: "71016" },
  { city: "Manfredonia", province: "FG", cap: "71043" },
  { city: "Lecce", province: "LE", cap: "73100" },
  { city: "Nardò", province: "LE", cap: "73048" },
  { city: "Gallipoli", province: "LE", cap: "73014" },
  { city: "Copertino", province: "LE", cap: "73043" },
  { city: "Taranto", province: "TA", cap: "74121" },
  { city: "Martina Franca", province: "TA", cap: "74015" },
  { city: "Massafra", province: "TA", cap: "74016" },
  { city: "Grottaglie", province: "TA", cap: "74023" },
  
  // SARDEGNA
  { city: "Cagliari", province: "CA", cap: "09100" },
  { city: "Quartu Sant'Elena", province: "CA", cap: "09045" },
  { city: "Selargius", province: "CA", cap: "09047" },
  { city: "Assemini", province: "CA", cap: "09032" },
  { city: "Carbonia", province: "SU", cap: "09013" },
  { city: "Iglesias", province: "SU", cap: "09016" },
  { city: "Nuoro", province: "NU", cap: "08100" },
  { city: "Oristano", province: "OR", cap: "09170" },
  { city: "Sassari", province: "SS", cap: "07100" },
  { city: "Alghero", province: "SS", cap: "07041" },
  { city: "Olbia", province: "SS", cap: "07026" },
  { city: "Tempio Pausania", province: "SS", cap: "07029" },
  
  // SICILIA
  { city: "Palermo", province: "PA", cap: "90100" },
  { city: "Bagheria", province: "PA", cap: "90011" },
  { city: "Carini", province: "PA", cap: "90044" },
  { city: "Monreale", province: "PA", cap: "90046" },
  { city: "Partinico", province: "PA", cap: "90047" },
  { city: "Catania", province: "CT", cap: "95100" },
  { city: "Acireale", province: "CT", cap: "95024" },
  { city: "Misterbianco", province: "CT", cap: "95045" },
  { city: "Paternò", province: "CT", cap: "95047" },
  { city: "Caltagirone", province: "CT", cap: "95041" },
  { city: "Messina", province: "ME", cap: "98100" },
  { city: "Barcellona Pozzo di Gotto", province: "ME", cap: "98051" },
  { city: "Milazzo", province: "ME", cap: "98057" },
  { city: "Agrigento", province: "AG", cap: "92100" },
  { city: "Sciacca", province: "AG", cap: "92019" },
  { city: "Licata", province: "AG", cap: "92027" },
  { city: "Caltanissetta", province: "CL", cap: "93100" },
  { city: "Gela", province: "CL", cap: "93012" },
  { city: "Enna", province: "EN", cap: "94100" },
  { city: "Ragusa", province: "RG", cap: "97100" },
  { city: "Vittoria", province: "RG", cap: "97019" },
  { city: "Modica", province: "RG", cap: "97015" },
  { city: "Comiso", province: "RG", cap: "97013" },
  { city: "Siracusa", province: "SR", cap: "96100" },
  { city: "Augusta", province: "SR", cap: "96011" },
  { city: "Noto", province: "SR", cap: "96017" },
  { city: "Trapani", province: "TP", cap: "91100" },
  { city: "Marsala", province: "TP", cap: "91025" },
  { city: "Mazara del Vallo", province: "TP", cap: "91026" },
  { city: "Alcamo", province: "TP", cap: "91011" },
  { city: "Castelvetrano", province: "TP", cap: "91022" },
  
  // TOSCANA
  { city: "Firenze", province: "FI", cap: "50100" },
  { city: "Scandicci", province: "FI", cap: "50018" },
  { city: "Sesto Fiorentino", province: "FI", cap: "50019" },
  { city: "Campi Bisenzio", province: "FI", cap: "50013" },
  { city: "Empoli", province: "FI", cap: "50053" },
  { city: "Bagno a Ripoli", province: "FI", cap: "50012" },
  { city: "Arezzo", province: "AR", cap: "52100" },
  { city: "Cortona", province: "AR", cap: "52044" },
  { city: "Grosseto", province: "GR", cap: "58100" },
  { city: "Follonica", province: "GR", cap: "58022" },
  { city: "Livorno", province: "LI", cap: "57100" },
  { city: "Piombino", province: "LI", cap: "57025" },
  { city: "Rosignano Marittimo", province: "LI", cap: "57016" },
  { city: "Cecina", province: "LI", cap: "57023" },
  { city: "Lucca", province: "LU", cap: "55100" },
  { city: "Viareggio", province: "LU", cap: "55049" },
  { city: "Capannori", province: "LU", cap: "55012" },
  { city: "Camaiore", province: "LU", cap: "55041" },
  { city: "Massa", province: "MS", cap: "54100" },
  { city: "Carrara", province: "MS", cap: "54033" },
  { city: "Pisa", province: "PI", cap: "56100" },
  { city: "Cascina", province: "PI", cap: "56021" },
  { city: "San Giuliano Terme", province: "PI", cap: "56017" },
  { city: "Pontedera", province: "PI", cap: "56025" },
  { city: "Pistoia", province: "PT", cap: "51100" },
  { city: "Montecatini Terme", province: "PT", cap: "51016" },
  { city: "Quarrata", province: "PT", cap: "51039" },
  { city: "Prato", province: "PO", cap: "59100" },
  { city: "Montemurlo", province: "PO", cap: "59013" },
  { city: "Siena", province: "SI", cap: "53100" },
  { city: "Poggibonsi", province: "SI", cap: "53036" },
  { city: "Colle di Val d'Elsa", province: "SI", cap: "53034" },
  
  // TRENTINO-ALTO ADIGE
  { city: "Trento", province: "TN", cap: "38122" },
  { city: "Rovereto", province: "TN", cap: "38068" },
  { city: "Pergine Valsugana", province: "TN", cap: "38057" },
  { city: "Bolzano", province: "BZ", cap: "39100" },
  { city: "Merano", province: "BZ", cap: "39012" },
  { city: "Bressanone", province: "BZ", cap: "39042" },
  { city: "Laives", province: "BZ", cap: "39055" },
  
  // UMBRIA
  { city: "Perugia", province: "PG", cap: "06100" },
  { city: "Foligno", province: "PG", cap: "06034" },
  { city: "Città di Castello", province: "PG", cap: "06012" },
  { city: "Spoleto", province: "PG", cap: "06049" },
  { city: "Gubbio", province: "PG", cap: "06024" },
  { city: "Terni", province: "TR", cap: "05100" },
  { city: "Orvieto", province: "TR", cap: "05018" },
  { city: "Narni", province: "TR", cap: "05035" },
  
  // VALLE D'AOSTA
  { city: "Aosta", province: "AO", cap: "11100" },
  { city: "Châtillon", province: "AO", cap: "11024" },
  { city: "Saint-Vincent", province: "AO", cap: "11027" },
  
  // VENETO
  { city: "Venezia", province: "VE", cap: "30100" },
  { city: "Mestre", province: "VE", cap: "30171" },
  { city: "Chioggia", province: "VE", cap: "30015" },
  { city: "San Donà di Piave", province: "VE", cap: "30027" },
  { city: "Mira", province: "VE", cap: "30034" },
  { city: "Spinea", province: "VE", cap: "30038" },
  { city: "Belluno", province: "BL", cap: "32100" },
  { city: "Feltre", province: "BL", cap: "32032" },
  { city: "Padova", province: "PD", cap: "35100" },
  { city: "Abano Terme", province: "PD", cap: "35031" },
  { city: "Cittadella", province: "PD", cap: "35013" },
  { city: "Selvazzano Dentro", province: "PD", cap: "35030" },
  { city: "Albignasego", province: "PD", cap: "35020" },
  { city: "Rovigo", province: "RO", cap: "45100" },
  { city: "Adria", province: "RO", cap: "45011" },
  { city: "Treviso", province: "TV", cap: "31100" },
  { city: "Conegliano", province: "TV", cap: "31015" },
  { city: "Montebelluna", province: "TV", cap: "31044" },
  { city: "Castelfranco Veneto", province: "TV", cap: "31033" },
  { city: "Vittorio Veneto", province: "TV", cap: "31029" },
  { city: "Mogliano Veneto", province: "TV", cap: "31021" },
  { city: "Verona", province: "VR", cap: "37100" },
  { city: "Villafranca di Verona", province: "VR", cap: "37069" },
  { city: "San Giovanni Lupatoto", province: "VR", cap: "37057" },
  { city: "Legnago", province: "VR", cap: "37045" },
  { city: "San Bonifacio", province: "VR", cap: "37047" },
  { city: "Bussolengo", province: "VR", cap: "37012" },
  { city: "Vicenza", province: "VI", cap: "36100" },
  { city: "Bassano del Grappa", province: "VI", cap: "36061" },
  { city: "Schio", province: "VI", cap: "36015" },
  { city: "Valdagno", province: "VI", cap: "36078" },
  { city: "Arzignano", province: "VI", cap: "36071" },
  { city: "Thiene", province: "VI", cap: "36016" },
];

// Mappa province con nomi completi
export const provinceMap = {
  "AG": "Agrigento",
  "AL": "Alessandria",
  "AN": "Ancona",
  "AO": "Aosta",
  "AP": "Ascoli Piceno",
  "AQ": "L'Aquila",
  "AR": "Arezzo",
  "AT": "Asti",
  "AV": "Avellino",
  "BA": "Bari",
  "BG": "Bergamo",
  "BI": "Biella",
  "BL": "Belluno",
  "BN": "Benevento",
  "BO": "Bologna",
  "BR": "Brindisi",
  "BS": "Brescia",
  "BT": "Barletta-Andria-Trani",
  "BZ": "Bolzano",
  "CA": "Cagliari",
  "CB": "Campobasso",
  "CE": "Caserta",
  "CH": "Chieti",
  "CL": "Caltanissetta",
  "CN": "Cuneo",
  "CO": "Como",
  "CR": "Cremona",
  "CS": "Cosenza",
  "CT": "Catania",
  "CZ": "Catanzaro",
  "EN": "Enna",
  "FC": "Forlì-Cesena",
  "FE": "Ferrara",
  "FG": "Foggia",
  "FI": "Firenze",
  "FM": "Fermo",
  "FR": "Frosinone",
  "GE": "Genova",
  "GO": "Gorizia",
  "GR": "Grosseto",
  "IM": "Imperia",
  "IS": "Isernia",
  "KR": "Crotone",
  "LC": "Lecco",
  "LE": "Lecce",
  "LI": "Livorno",
  "LO": "Lodi",
  "LT": "Latina",
  "LU": "Lucca",
  "MB": "Monza e Brianza",
  "MC": "Macerata",
  "ME": "Messina",
  "MI": "Milano",
  "MN": "Mantova",
  "MO": "Modena",
  "MS": "Massa-Carrara",
  "MT": "Matera",
  "NA": "Napoli",
  "NO": "Novara",
  "NU": "Nuoro",
  "OR": "Oristano",
  "PA": "Palermo",
  "PC": "Piacenza",
  "PD": "Padova",
  "PE": "Pescara",
  "PG": "Perugia",
  "PI": "Pisa",
  "PN": "Pordenone",
  "PO": "Prato",
  "PR": "Parma",
  "PT": "Pistoia",
  "PU": "Pesaro e Urbino",
  "PV": "Pavia",
  "PZ": "Potenza",
  "RA": "Ravenna",
  "RC": "Reggio Calabria",
  "RE": "Reggio Emilia",
  "RG": "Ragusa",
  "RI": "Rieti",
  "RM": "Roma",
  "RN": "Rimini",
  "RO": "Rovigo",
  "SA": "Salerno",
  "SI": "Siena",
  "SO": "Sondrio",
  "SP": "La Spezia",
  "SR": "Siracusa",
  "SS": "Sassari",
  "SU": "Sud Sardegna",
  "TA": "Taranto",
  "TE": "Teramo",
  "TN": "Trento",
  "TO": "Torino",
  "TP": "Trapani",
  "TR": "Terni",
  "TS": "Trieste",
  "TV": "Treviso",
  "UD": "Udine",
  "VA": "Varese",
  "VB": "Verbano-Cusio-Ossola",
  "VC": "Vercelli",
  "VE": "Venezia",
  "VI": "Vicenza",
  "VR": "Verona",
  "VT": "Viterbo",
};

// Funzione helper per cercare città
export const searchCities = (query) => {
  if (!query || query.length < 2) return [];
  const normalizedQuery = query.toLowerCase().trim();
  return italianCities
    .filter(c => c.city.toLowerCase().includes(normalizedQuery))
    .slice(0, 10); // Limita a 10 risultati
};

// Funzione per ottenere provincia da città
export const getProvinceByCity = (cityName) => {
  const city = italianCities.find(
    c => c.city.toLowerCase() === cityName.toLowerCase()
  );
  return city ? city.province : "";
};

// Funzione per ottenere CAP da città
export const getCapByCity = (cityName) => {
  const city = italianCities.find(
    c => c.city.toLowerCase() === cityName.toLowerCase()
  );
  return city ? city.cap : "";
};
